export const stripeKey = 'pk_test_CTUTK7bBw6sSIaZnKEZNYxiz00UKEEubeG';

// TODO: use api to get plan id
export const stripeSubscriptionPlan = 'plan_FMxuRoC0e4ELs8';

export default {
  stripeKey,
};
